import React from 'react';
import PropTypes from 'prop-types';
import { classnames } from 'Utils/classnames';
import SafeImage from 'Components/SafeImage';
import { DEFAULT_LOGOS, getCompetitionLogoUrl } from 'Utils/bulletinLogo';

const truncateLabel = label =>
  typeof label === 'string' && label.length > 30 ? `${label.slice(0, 30)}...` : label;

const getLabelText = (label, truncate) => (truncate ? truncateLabel(label) : label);

const Checkbox = props => {
  const containerClass = classnames({
    checkbox: true,
    [props.className]: props.className,
    'checkbox--checked': props.checked
  });

  const checkboxClass = classnames({
    checkbox__item: true,
    'checkbox__item--checked': props.checked,
    'checkbox__item--disabled': props.disabled,
  });

  const checkboxLabelClass = classnames({
    checkbox__label: true,
    'checkbox__label--checked': props.checked,

  });

  const isHyperlink = !!props?.isHyperLink?.status;

  const handleClick = e => {
    e.stopPropagation();
    e.preventDefault();

    if (!props.disabled) {
      props.onChange();
    }
  };

  const handleKeyPress = event => {
    if (event.charCode === 32) {
      event.preventDefault();
      handleClick(event);
    }
  };

  const label = props.label ? (
    <div className={ checkboxLabelClass } >

      { props.competitionId && (
        <div className="checkbox__logo">
          <SafeImage
            src={ getCompetitionLogoUrl(props.competitionId) }
            fallback={ DEFAULT_LOGOS.competition }
            alt="competitionLogo"
          />
        </div>
      ) }

      { getLabelText(props.label, props.truncateLabel) }

    </div>
  ) : null;

  return (
    <div
      className={ containerClass }
      onClick={ handleClick }
      role="checkbox"
      tabIndex="0"
      aria-checked={ props.checked }
      onKeyPress={ handleKeyPress }
    >
      <div className={ checkboxClass } />

      { props.children }

      { isHyperlink
        ? (
          <a id="hyperLink" href={ props?.isHyperLink?.url } title={ props.label }>
            { label }
          </a>
        )
        : label
      }
    </div>
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  truncateLabel: PropTypes.bool,
  children: PropTypes.element,
  isHyperLink: PropTypes.object,

  /** new */
  competitionId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

export default Checkbox;
